import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "@/store/index";

type LocationState = { locationId: string; locationName: string };

const initialState: LocationState = { locationId: "", locationName: "" };

const envChecklistSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    setLocation: (state, action: PayloadAction<LocationState>) => {
      state.locationId = action.payload.locationId;
      state.locationName = action.payload.locationName;
    },
    resetLocation: () => initialState,
  },
});

export const { setLocation, resetLocation } = envChecklistSlice.actions;
export const selectLocation = (state: RootState) => state.location;

export const locationReducer = envChecklistSlice.reducer;
